var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { InlineToolbarButtons, Plugins, PluginToolbarButtons, } from '../DaEditor/enums';
import portalDecorator from '../DaEditor/plugins/plugin-text-tools/toolbar/portalDecorator';
import { EditorFlavours } from './types';
import { Image } from './PluginComponents/Image';
import { Gallery } from './PluginComponents/Gallery';
import { MediaSourceType } from '../MediaPopup/types';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
import { isEmptyFeature, wordCountFeature, mediaCountFeature, firstImageFeature, } from './Features';
var imageCanBeLinked = function (componentData) {
    if (componentData && componentData.data) {
        // can be linked only if not published
        return !componentData.data.isPublished;
    }
    return true;
};
var imageCanBeFullWidth = function (componentData) {
    if (componentData && componentData.data && componentData.data.deviationId) {
        return getDeviationType(componentData.data) === DeviationTypes.IMAGE;
    }
    return true;
};
var giphyConfig = {
    toolbar: {
        hidden: [
            'sizeOriginal',
            'sizeFullWidth',
            'sizeSmallLeft',
            'sizeSimallRight',
            'sizeSmallCenter',
            'sizeContent',
            'separator1',
            'separator2',
        ],
    },
    giphySdkApiKey: 'dCf5MVSF00OQO1mlKr5DoNPO9OpOrlhj',
    componentDataDefaults: {
        config: {
            size: 'small',
            alignment: 'center',
        },
    },
    insertToolbars: ['SIDE', 'FOOTER'],
};
var defaultFeatures = [
    isEmptyFeature,
    wordCountFeature,
    mediaCountFeature,
    firstImageFeature,
];
/**
 * Actual config
 *
 * taken from: https://docs.google.com/spreadsheets/d/1yLI5z0DtUlnLpMZlHqUFuynmOTpl1fkryQ4kg-CTUgI/edit?ts=5b291b5a#gid=0
 */
export var EditorFlavourConfigs = (_a = {},
    _a[EditorFlavours.Journal] = {
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.TITLE,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
            InlineToolbarButtons.BLOCKQUOTE,
        ],
        featureConfig: [isEmptyFeature, wordCountFeature, mediaCountFeature],
        pluginsConfig: (_b = {},
            _b[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.FULL_WIDTH,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _b[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.FULL_WIDTH,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _b[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.FULL_WIDTH,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _b[Plugins.EMOTES] = {},
            _b[Plugins.MENTION] = {},
            _b[Plugins.LINK] = {},
            _b[Plugins.TEXT_TOOLS] = {},
            _b[Plugins.GIPHY] = giphyConfig,
            _b[Plugins.HASHTAG] = {},
            _b),
    },
    _a[EditorFlavours.Literature] = {
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.TITLE,
            InlineToolbarButtons.ALIGNMENT,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
            InlineToolbarButtons.BLOCKQUOTE,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_c = {},
            _c[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.FULL_WIDTH,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _c[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.FULL_WIDTH,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _c[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.FULL_WIDTH,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _c[Plugins.EMOTES] = {},
            _c[Plugins.MENTION] = {},
            _c[Plugins.LINK] = {},
            _c[Plugins.HASHTAG] = {},
            _c),
    },
    _a[EditorFlavours.StatusShort] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [InlineToolbarButtons.LINK],
        featureConfig: defaultFeatures,
        pluginsConfig: (_d = {},
            _d[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _d[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _d[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _d[Plugins.EMOTES] = {},
            _d[Plugins.MENTION] = {},
            _d[Plugins.LINK] = {},
            _d[Plugins.GIPHY] = giphyConfig,
            _d[Plugins.HASHTAG] = {},
            _d),
    },
    _a[EditorFlavours.SatusLong] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_e = {},
            _e[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _e[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _e[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _e[Plugins.EMOTES] = {},
            _e[Plugins.MENTION] = {},
            _e[Plugins.LINK] = {},
            _e[Plugins.GIPHY] = giphyConfig,
            _e[Plugins.HASHTAG] = {},
            _e),
    },
    _a[EditorFlavours.Comment] = {
        extraProps: {
            showMediaAlwaysSmall: true,
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_f = {},
            _f[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _f[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _f[Plugins.VIDEO] = {
                toolbar: [PluginToolbarButtons.REPLACE, PluginToolbarButtons.DELETE],
            },
            _f[Plugins.EMOTES] = {},
            _f[Plugins.MENTION] = {},
            _f[Plugins.LINK] = {},
            _f[Plugins.GIPHY] = giphyConfig,
            _f[Plugins.HASHTAG] = {},
            _f),
    },
    _a[EditorFlavours.Commission] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_g = {},
            _g[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _g[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _g[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _g[Plugins.EMOTES] = {},
            _g[Plugins.LINK] = {},
            _g),
        mediaSourceTypes: [MediaSourceType.GALLERY, MediaSourceType.STASH],
    },
    _a[EditorFlavours.DeviantId] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_h = {},
            _h[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _h[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _h[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _h[Plugins.EMOTES] = {},
            _h[Plugins.LINK] = {},
            _h),
    },
    _a[EditorFlavours.PollAnswer] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [],
        featureConfig: defaultFeatures,
        pluginsConfig: (_j = {},
            _j[Plugins.EMOTES] = {},
            _j),
    },
    _a[EditorFlavours.Donation] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [],
        featureConfig: defaultFeatures,
        pluginsConfig: (_k = {},
            _k[Plugins.EMOTES] = {},
            _k[Plugins.LINK] = {},
            _k),
    },
    _a[EditorFlavours.CustomBox] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.TEXT_TOOLS_COLOR,
            InlineToolbarButtons.ALIGNMENT,
            InlineToolbarButtons.LINK,
            InlineToolbarButtons.SEPARATOR,
            InlineToolbarButtons.TITLE,
            InlineToolbarButtons.ORDERED_LIST,
            InlineToolbarButtons.UNORDERED_LIST,
            InlineToolbarButtons.BLOCKQUOTE,
        ],
        featureConfig: defaultFeatures,
        pluginsConfig: (_l = {},
            _l[Plugins.IMAGE] = {
                component: Image,
                canBeLinked: imageCanBeLinked,
                canBeFullWidth: imageCanBeFullWidth,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.LINK,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _l[Plugins.GALLERY] = {
                component: Gallery,
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.LAYOUT_GRID,
                    PluginToolbarButtons.LAYOUT_MASONRY,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _l[Plugins.VIDEO] = {
                toolbar: [
                    PluginToolbarButtons.BEST_FIT,
                    PluginToolbarButtons.ALIGN_LEFT,
                    PluginToolbarButtons.ALIGN_RIGHT,
                    PluginToolbarButtons.SEPARATOR,
                    PluginToolbarButtons.REPLACE,
                    PluginToolbarButtons.DELETE,
                ],
            },
            _l[Plugins.EMOTES] = {},
            _l[Plugins.MENTION] = {},
            _l[Plugins.LINK] = {},
            _l[Plugins.TEXT_TOOLS] = {},
            _l[Plugins.GIPHY] = giphyConfig,
            _l[Plugins.HASHTAG] = {},
            _l),
    },
    _a[EditorFlavours.Chat] = {
        extraProps: {
            hideSideToolbar: true,
        },
        toolbars: [],
        textTools: [
            InlineToolbarButtons.BOLD,
            InlineToolbarButtons.ITALIC,
            InlineToolbarButtons.UNDERLINE,
            InlineToolbarButtons.LINK,
        ],
        textToolbarDecoratorFn: portalDecorator({ portalId: 'chat-text-tools' }),
        featureConfig: defaultFeatures,
        pluginsConfig: (_m = {},
            _m[Plugins.LINK] = {},
            _m[Plugins.EMOTES] = {},
            _m[Plugins.TEXT_TOOLS] = {},
            _m),
    },
    _a);
//# sourceMappingURL=config.js.map